import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useOrganizationStore } from '@/core/stores/organization.store';
import { clientsService } from '../api/clients.service';
import { CLIENTS_KEYS } from './queryKeys';

export function useDeleteClient() {
  const queryClient = useQueryClient();
  const activeOrganizationId = useOrganizationStore((s) => s.activeOrganizationId);

  return useMutation({
    mutationFn: (clientId: string) => clientsService.delete(clientId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: CLIENTS_KEYS.byOrg(activeOrganizationId!) });
    },
  });
}
